module.exports = __webpack_public_path__ + "static/img/26.c5fe45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/26.png
// module id = 3UOz
// module chunks = 0